<template>
    <div class="footer_block">
        <div style="padding-top: 31px;" class="center">
        <p class="footer_one">© 2021 EBM Technologies.</p>
        <p class="footer_two">{{ $t("footer.rights") }}</p>
        <p class="footer_three" @click="tnc" style="cursor:pointer;">{{ $t("footer.terms") }}</p>
        <p class="footer_four" @click="privacyPolicy" style="cursor:pointer;">{{ $t("footer.privacy") }}</p>
        </div>
        <div style="padding-top: 31px;" class="mo">
        <p class="footer_one">© 2021 EBM Technologies.</p><br>
        <p class="footer_two">{{ $t("footer.rights") }}</p><br>
        <p class="footer_three" @click="tnc" style="cursor:pointer;">{{ $t("footer.terms") }}</p>
        <p class="footer_four" @click="privacyPolicy" style="cursor:pointer;">{{ $t("footer.privacy") }}</p>
        </div>
    </div>
</template>
<script>
export default {
    methods:{
        privacyPolicy(){
            var url = 'http://www.ebmtech.com/privacyPolicy.php/';
            var win = window.open(url, '_blank');
            win.focus();
        },
        tnc(){
            var url = 'http://www.ebmtech.com/termsofUse.php';
            var win = window.open(url, '_blank');
            win.focus();
        },
    }
}
</script>
<style scoped>
.pc{
    display: block;
}
.mo{
    display: none;
}
p:hover{
    color: #00BEFF;
}
.footer_block{
    height: 100px;
    background: #1C2126 0% 0% no-repeat padding-box;
}
.footer_one{
    display: inline-block;
    color: #FFFFFF;
    font-weight: bold;
    font-size: 14px;
    margin-left: 100px;
}
.footer_two{
    display: inline-block;
    color: #828282;
    font-weight: bold;
    font-size: 14px;
    margin-left: 78px;
}
.footer_three{
    margin-right: 134px;
    float: right;
    color: #828282;
    font-weight: bold;
    font-size: 14px;
}
.footer_four{
    margin-right: 45px;
    float:right;
    color: #828282;
    font-weight: bold;
    font-size: 14px;
}
@media (max-width: 1080px){
    .footer_one{
    margin-left: 40px;
}
.footer_two{
    margin-left: 28px;
}
.footer_three{
    margin-right: 28px;
}
.footer_four{
    margin-right: 40px;
}
}


@media screen and (max-width: 670px){
    .footer_block{
    height: 180px;
    background: #1C2126 0% 0% no-repeat padding-box;
}
.center{
    text-align: center;
}
.footer_one{
    display:block;
    margin-left: 0px;
}
.footer_two{
    display: block;
    margin-left: 0px;
}
.footer_three{
    margin-right: 0px;
    float:none;
}
.footer_four{
    margin-right: 0px;
    float:none;
}
}

</style>